//Rudimentary logger
export const logError = (message: string, location?: string) => {
  const envStore = useEnvStore()
  if (envStore.environment !== 'production') {
    console.group('Error at location: ' + location)
    console.error('Message: ', message)
    console.groupEnd()
  }
}
